<script>
  export let show = false;
  export let down = "";
</script>

{#if show}
  <div class="dropdown" class:sm={down === "sm"} class:md={down === "md"}>
    <slot />
  </div>
{/if}

<style>
  div {
    background-color: #fff;
    box-shadow: 0 0 2rem rgba(0, 0, 0, 0.15);
    position: absolute;
    width: 100%;
    top: 5rem;
    right: 0;
    color: #000;
    border-radius: 2px;
    font-family: "Inter", sans-serif;
    font-weight: 400;
    z-index: 5;
    max-height: 70rem;
    overflow-y: auto;
  }

  div.sm {
    top: 8rem;
  }

  div.md {
    top: 12rem;
  }

  :global(.dropdown > *) {
    padding: 1.5rem;
    display: block;
  }

  :global(.dropdown > *:hover) {
    background-color: rgba(0, 0, 0, 0.2);
  }
</style>
